// "Ready to get flipped?" — one line, one button. The page already made
// the case. Clicking the button scrolls up to #contact (the form) OR, once the
// form section is built, can navigate to a dedicated /book route.
import PanBar from "../components/PanBar";

export default function CtaFinal() {
  return (
    <section
      id="contact"
      style={{
        background: "radial-gradient(ellipse 80% 55% at 50% 45%, rgba(239,83,126,0.22) 0%, transparent 60%), linear-gradient(180deg, #0e2e46 0%, #081a2a 100%)",
        padding: "6rem 1.5rem",
        textAlign: "center",
      }}
    >
      <PanBar width={96} height={4} margin="0 auto 1.3rem" />
      <h2 style={{
        margin: "0 0 2rem",
        fontFamily: "var(--jop-script)",
        fontSize: "clamp(2rem, 5.5vw, 3.4rem)",
        color: "var(--jop-gold)",
        fontWeight: 700,
        letterSpacing: "-0.01em",
      }}>
        Ready to get flipped?
      </h2>

      <a
        href="/quote"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          padding: "1.1rem 2.4rem",
          background: "linear-gradient(180deg, #ff6b95 0%, #ef537e 55%, #c93a66 100%)",
          color: "white",
          fontFamily: "var(--jop-display)",
          fontSize: "1.15rem",
          fontWeight: 900,
          letterSpacing: "0.03em",
          textDecoration: "none",
          borderRadius: "999px",
          boxShadow: "0 8px 28px rgba(239,83,126,0.55), 0 0 0 1px rgba(255,255,255,0.22) inset, 0 0 36px rgba(239,83,126,0.25)",
          transition: "transform 0.15s ease, box-shadow 0.15s ease",
          textShadow: "0 1px 0 rgba(0,0,0,0.2)",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 14px 36px rgba(239,83,126,0.7), 0 0 0 1px rgba(255,255,255,0.3) inset, 0 0 48px rgba(239,83,126,0.35)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 8px 28px rgba(239,83,126,0.55), 0 0 0 1px rgba(255,255,255,0.22) inset, 0 0 36px rgba(239,83,126,0.25)";
        }}
      >
        Get a Quote
      </a>
    </section>
  );
}
